import { createAsyncThunk } from '@reduxjs/toolkit';
import { DealerSettings } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { GetDealerSettings, } from './interface';


export const getDealerSettings = createAsyncThunk(
  'dealerSettings/getDealerSettings',
  async ({ id }: GetDealerSettings, { rejectWithValue }) => {
    try {
      const response = await DealerSettings.get(id);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
